module.exports = "/static/media/error-character.b537feb1.svg";